module.exports = __webpack_public_path__ + "static/media/BSP1.39f8b62f.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/BSP1.png
// module id = 889
// module chunks = 0